
import { useUiStore } from "../stores/uiStore";
import type { SidePanelTab } from "../stores/types";

/** Side panel chrome state */
export function useSidePanel() {
  const sidePanelOpen = useUiStore((s) => s.sidePanelOpen);
  const sidePanelTab = useUiStore((s) => s.sidePanelTab);
  const setSidePanelOpen = useUiStore((s) => s.setSidePanelOpen);
  const toggleSidePanel = useUiStore((s) => s.toggleSidePanel);
  const setSidePanelTab = useUiStore((s) => s.setSidePanelTab);

  return {
    sidePanelOpen,
    sidePanelTab,
    setSidePanelOpen,
    toggleSidePanel,
    setSidePanelTab,
  };
}

export type { SidePanelTab };
